import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import Onboard from 'pages/Dashboard/Onboard/Onboard';
import { InviteType } from 'constants/enums';

interface IBulkOrderAccessoriesProps {
  close: (refetch?: boolean) => void;
}

const BulkOrderAccessories = ({ close }: IBulkOrderAccessoriesProps) => {
  const intl = useIntl();

  return (
    <Modal show onHide={close} size="xl" backdrop="static" data-test="bulk-order-accessories-modal">
      <Modal.Header className="align-items-center" closeButton>
        <Modal.Title>{intl.formatMessage({ id: 'orderAccessoriesKey' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0">
        <div className="position-relative">
          <Onboard
            inviteType={InviteType.BULK_ORDER_ACCESSORIES}
            fallback={(status: boolean) => close(status)}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BulkOrderAccessories;
